import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "groups" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Input = _resolveComponent("Input")
  const _component_TextArea = _resolveComponent("TextArea")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Button = _resolveComponent("Button")
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createBlock(_component_Modal, {
    ref: "modal",
    "modal-to": "#tenants",
    min_width: "min(68rem, 100%)",
    centered: false,
    onClickOutside: $options.close
  }, {
    header: _withCtx(() => _cache[8] || (_cache[8] = [
      _createTextVNode(" Edit User ")
    ])),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[12] || (_cache[12] = _createElementVNode("label", null, "First Name", -1 /* HOISTED */)),
        _createVNode(_component_Input, {
          ref: "i_fname",
          modelValue: $data.first_name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.first_name) = $event)),
          "vread-from": "valid",
          "onUpdate:valid": $event => (($data.first_name_valid) = $event),
          minlength: 3,
          maxlength: 125,
          required: ""
        }, null, 8 /* PROPS */, ["modelValue", "onUpdate:valid"]),
        _cache[13] || (_cache[13] = _createElementVNode("label", null, "Last Name", -1 /* HOISTED */)),
        _createVNode(_component_Input, {
          ref: "i_lname",
          modelValue: $data.last_name,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.last_name) = $event)),
          "vread-from": "valid",
          "onUpdate:valid": $event => (($data.last_name_valid) = $event),
          minlength: 3,
          maxlength: 125,
          required: ""
        }, null, 8 /* PROPS */, ["modelValue", "onUpdate:valid"]),
        _cache[14] || (_cache[14] = _createElementVNode("label", null, "Title", -1 /* HOISTED */)),
        _createVNode(_component_Input, {
          modelValue: $data.title,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.title) = $event)),
          maxlength: 100
        }, null, 8 /* PROPS */, ["modelValue"]),
        _cache[15] || (_cache[15] = _createElementVNode("label", null, "Bio", -1 /* HOISTED */)),
        _createVNode(_component_TextArea, {
          modelValue: $data.bio,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.bio) = $event)),
          class: "textarea",
          maxlength: 2048,
          rows: 6
        }, null, 8 /* PROPS */, ["modelValue"]),
        _cache[16] || (_cache[16] = _createElementVNode("label", null, "Offering", -1 /* HOISTED */)),
        _createVNode(_component_TextArea, {
          modelValue: $data.offering,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($data.offering) = $event)),
          class: "textarea",
          maxlength: 2048,
          rows: 6
        }, null, 8 /* PROPS */, ["modelValue"]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Checkbox, {
            modelValue: $data.is_superuser,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($data.is_superuser) = $event)),
            "font-size": "1.4rem"
          }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [
              _createTextVNode("Superuser")
            ])),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue"]),
          _createVNode(_component_Checkbox, {
            modelValue: $data.is_beta,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($data.is_beta) = $event)),
            "font-size": "1.4rem"
          }, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [
              _createTextVNode("Beta")
            ])),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue"]),
          _createVNode(_component_Checkbox, {
            modelValue: $data.is_tenant_manager,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($data.is_tenant_manager) = $event)),
            "font-size": "1.4rem"
          }, {
            default: _withCtx(() => _cache[11] || (_cache[11] = [
              _createTextVNode("Tenant Manager")
            ])),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue"])
        ])
      ])
    ]),
    controls: _withCtx(() => [
      _createVNode(_component_Button, { onClick: $options.close }, {
        default: _withCtx(() => _cache[17] || (_cache[17] = [
          _createTextVNode(" Cancel ")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["onClick"]),
      _createVNode(_component_Button, {
        primary: "",
        disabled: !$options.can_submit,
        onClick: $options.submit
      }, {
        default: _withCtx(() => _cache[18] || (_cache[18] = [
          _createTextVNode(" Update ")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled", "onClick"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["onClickOutside"]))
}